import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import CommissionLineService from '../../../Services/CommissionLineService';
import CommissionLineDetailSearchParams from './CommissionLineDetailSearchParams';
import ErrorMessage from '../../../Elements/ErrorMessage';
import CommissionLineDetailItem from '../../../Domain/CommissionLineDetailItem';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditCommissionLineWindowDescription from './EditCommissionLineWIndowDescription';

export default class CommissionLineDetailAdmin extends React.Component {
  static defaultProps = {
    selectedUserId: null,
    selectedExternalSalesPartnerId: null,
    opportunityId: null,
    clientId: null,
    serviceId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      shownPanel: ShownPanelsEnum.None,
      searchItem: new CommissionLineDetailSearchParams(),
    };

    if (props.selectedUserId) {
      this.state.searchItem.SelectedUserIds = [props.selectedUserId.toString()];
    } else if (props.selectedExternalSalesPartnerId) {
      this.state.searchItem.SelectedExternalSalesPartnerId = props.selectedExternalSalesPartnerId;
    }

    if (props.selectedUserId || props.selectedExternalSalesPartnerId) {
      this.state.searchItem.ClientIds = [props.clientId.toString()];
      this.state.searchItem.OpportunityIds = [props.opportunityId.toString()];
      this.state.searchItem.ServiceIds = [props.serviceId.toString()];
    }

    this.refresh = this.refresh.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    CommissionLineDetailItem.editFunction = this.editFunction.bind(this);
    CommissionLineDetailItem.removeFunction = this.removeFunction.bind(this);
    this.createFunction = this.createFunction.bind(this);
  }

  handleExportExcelButtonClick() {
    CommissionLineService.ExportAdminExcelAsync(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('CLA32')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  editFunction(id, item) {
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  removeFunction(id, item) {
    ErrorMessage.SetApprove('Removing a Commission Line cannot be undone.', () => {
      CommissionLineService.RemoveItem(id, item.CommissionedUserId)
        .then((response) => {
          if (response.error) {
            ErrorMessage.SetErrorMessage(response.error);
            return;
          }
          this.refresh(true);
        })
        .catch((error) => ErrorMessage.SetErrorMessage('CLA50', error));
    });
  }

  refresh(refresh = false, searchItem = null) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...(searchItem ?? this.state.searchItem) } });
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  createFunction() {
    const selectedItem = new CommissionLineDetailItem();
    selectedItem.CommissionedUserId = this.props.selectedUserId;
    selectedItem.ClientId = this.props.clientId;
    selectedItem.ServiceId = this.props.serviceId;
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.AddNewItem,
    });
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              iconName: 'fa-solid fa-plus-circle',
              onClick: this.createFunction,
              tooltip: 'New Commission Line',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditCommissionLineWindowDescription}
            errorCode='CRA93'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditCommissionLineWindowDescription}
            errorCode='CRA93'
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={CommissionLineDetailItem}
          serviceFunction={CommissionLineService.GetDetailListBySearching}
          convertDBItemsFunction={CommissionLineService.ConvertDBDetailItems}
          searchParamsType={CommissionLineDetailSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={(searchItem) => this.refresh(true, searchItem)}
          searchItem={this.state.searchItem}
          orderBy='SourceFinalizedOnUtc'
          orderDirection='Desc'
          errorCode='CLA162'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in various fields...'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          shownPanel={this.state.shownPanel}
        />
      </div>
    );
  }
}
